/*
 * @Author: xxx
 * @Date: 2023-03-16 13:32:58
 * @LastEditors: xxx
 * @LastEditTime: 2023-03-16 13:35:59
 * @Description:
 */
import request from "@/utils/request";

// 获取问题列表
export function getList(params: any) {
  return request({
    url: "api/client/qanda/list",
    method: "get",
    params
  });
}
